import React, { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { motion } from 'framer-motion'
import { HiMenu, HiX } from 'react-icons/hi'

const Header = () => {
  const location = useLocation()
  const [isScrolled, setIsScrolled] = useState(false)
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50)
    }
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const menuItems = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Partners', path: '/partners' },
  ]

  return (
    <>
      {/* Main Navigation */}
      <motion.nav
        initial={{ y: -20, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.5 }}
        className={`sticky top-0 z-50 w-full max-w-full transition-all duration-300 ${
          isScrolled ? 'shadow-md' : ''
        }`}
        style={{ backgroundColor: '#DFF7D0' }}
      >
        <div className="container mx-auto px-4 w-full max-w-full min-w-0">
          <div className="flex items-center justify-between py-4 min-w-0">
            {/* Logo */}
            <Link to="/">
              <motion.div
                whileHover={{ scale: 1.05 }}
                className="flex items-center cursor-pointer"
              >
                <img
                  src="/d23d4450d678b9d5af881dc3b9d923ef2fb50ec7.webp"
                  alt="ReGreen Logo"
                  className="h-8 lg:h-12 w-auto object-contain"
                  width={572}
                  height={124}
                  loading="eager"
                  fetchpriority="high"
                  decoding="async"
                />
              </motion.div>
            </Link>

            {/* Desktop Menu */}
            <div className="hidden lg:flex items-center space-x-6">
              {menuItems.map((item, index) => {
                const isActive = location.pathname === item.path || (item.path === '/' && location.pathname === '/')
                return (
                <div
                  key={index}
                  className="relative group"
                >
                  <Link
                    to={item.path}
                    className={`font-medium transition-colors ${
                      isActive ? 'border-b-2 pb-1' : ''
                    }`}
                    style={{ 
                      color: '#546956',
                      borderColor: isActive ? '#99FF75' : 'transparent'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.color = '#102D12'
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.color = '#546956'
                    }}
                  >
                    {item.name}
                  </Link>
                </div>
              )})}
              <Link to="/#contact">
                <motion.div
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  className="px-6 py-2 rounded-lg font-semibold transition-colors cursor-pointer"
                  style={{
                    backgroundColor: '#99FF75',
                    color: '#546956'
                  }}
                  onMouseEnter={(e) => {
                    e.target.style.backgroundColor = '#6AA84F'
                    e.target.style.color = '#ffffff'
                  }}
                  onMouseLeave={(e) => {
                    e.target.style.backgroundColor = '#99FF75'
                    e.target.style.color = '#546956'
                  }}
                >
                  Contact Us
                </motion.div>
              </Link>
            </div>

            {/* Mobile Menu Button */}
            <button
              className="lg:hidden"
              style={{ color: '#102D12' }}
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            >
              {isMobileMenuOpen ? (
                <HiX className="text-2xl" />
              ) : (
                <HiMenu className="text-2xl" />
              )}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && (
          <motion.div
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            className="lg:hidden border-t"
            style={{ backgroundColor: '#DFF7D0' }}
          >
            <div className="container mx-auto px-4 py-4 space-y-2">
              {menuItems.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className="block py-2 font-medium"
                  style={{ color: '#546956' }}
                  onClick={() => setIsMobileMenuOpen(false)}
                >
                  {item.name}
                </Link>
              ))}
              <Link
                to="/#contact"
                className="block mt-4 px-6 py-2 rounded-lg font-semibold text-center"
                style={{
                  backgroundColor: '#99FF75',
                  color: '#546956'
                }}
                onClick={() => setIsMobileMenuOpen(false)}
              >
                Contact Us
              </Link>
            </div>
          </motion.div>
        )}
      </motion.nav>
    </>
  )
}

export default Header

